import fetchAPI from "../utils/fetchAPI";

const getPosts = async ( settings, selectedTax, page = 1 ) => {
    let url = `${settings.apiBase}/get-posts?post_type=${settings.postType}&posts_per_page=${settings.postsPerPage}&paged=${page}`;
    Object.entries(selectedTax).map( ([tax, term]) => {
        url += `&tax[${tax}]=${term}`;
    } )

    return await fetchAPI( url )
}

export default getPosts;